import React from 'react'
import FormFieldProps from '@App/forms/v2/common/form-field'
import { Controller, useFormContext } from 'react-hook-form'
import { ChangeEvent } from 'react-autosuggest'
import AutoCompleteInput from '@Components/Search/AutoCompleteInput'
import { AutoCompleteFetcher } from '@App/stores/search/models/select-option-hide'

interface AutoCompleteInputFormProps extends FormFieldProps {
    autoCompleteFetcher: AutoCompleteFetcher
    autoCompleteField: string
}

const AutoCompleteInputForm = (props: AutoCompleteInputFormProps) => {
    const { control, setValue } = useFormContext()
    const inputName = props.name
    const { autoCompleteFetcher, autoCompleteField } = props

    const onSuggestionSelected = (suggestion: string) => {
        setValue(inputName, suggestion)
    }

    const onInputChange = (_event: React.FormEvent<HTMLElement>, params: ChangeEvent) => {
        setValue(inputName, params.newValue, { shouldDirty: true })
    }

    return (
        <Controller
            name={inputName}
            control={control}
            render={({ field: { value, onChange, onBlur, name } }) => (
                <AutoCompleteInput
                    inputName={name}
                    onSelectedSuggestion={onSuggestionSelected}
                    autoCompleteFetcher={autoCompleteFetcher}
                    autoCompleteField={autoCompleteField}
                    onChange={onInputChange}
                    onBlur={onBlur}
                    value={value}
                />
            )}
        />
    )
}

export default AutoCompleteInputForm
